// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"1":"student","328":"admin","756":"professor"}[chunkId] || chunkId) + "." + {"1":"8805a9a6","64":"57e48ea7","328":"1c5a5501","756":"3bfb9438"}[chunkId] + ".js";
};